const DEFAULT_ERROR_MESSAGE = 'Undefined middleware name index. This name is reserved';

export default class ReservedMiddlewareModuleName extends Error {
  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super(message);
  }
}
